import areIntlLocalesSupported from 'intl-locales-supported'


export const getDateTimeFormat = () => {
  if (areIntlLocalesSupported(["fr", "fa-IR"])) {
    return global.Intl.DateTimeFormat;
  } else {
    const IntlPolyfill = require("intl");
    return IntlPolyfill.DateTimeFormat;
    require("intl/locale-data/jsonp/fr");
    require("intl/locale-data/jsonp/fa-IR");
  }
}
